import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import * as solidIcons from '@fortawesome/pro-solid-svg-icons';
import * as regularIcons from '@fortawesome/pro-regular-svg-icons';
import * as lightIcons from '@fortawesome/pro-light-svg-icons';

export function getIconDefinition(iconName: string): IconDefinition | undefined {
  if (!iconName) {
    // Warning: getIconDefinition: iconName is empty or undefined
    return undefined;
  }
  
  // Try to find the icon in different icon sets
  const iconKey = iconName.startsWith('fa') 
    ? iconName 
    : `fa${iconName.split('-').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join('')}`;
  
  // Check solid icons first
  if ((solidIcons as any)[iconKey]) {
    return (solidIcons as any)[iconKey];
  }
  
  // Then regular icons
  if ((regularIcons as any)[iconKey]) {
    return (regularIcons as any)[iconKey];
  }
  
  // Finally light icons
  if ((lightIcons as any)[iconKey]) {
    return (lightIcons as any)[iconKey];
  }
  
  // Warning: getIconDefinition: Icon  not found in FontAwesome icon sets`);
  return undefined;
}